import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/list-item/list-item.tsx
import { Slot } from "@radix-ui/react-slot";
import React, { forwardRef } from "react";
var DEFAULT_SIZE = "md";
var ListItem = forwardRef(
  ({
    className,
    isSelected = false,
    isInteractive = false,
    asChild = false,
    size = DEFAULT_SIZE,
    ...props
  }, forwardedRef) => {
    const Comp = asChild ? Slot : "div";
    return /* @__PURE__ */ React.createElement(
      Comp,
      {
        ref: forwardedRef,
        className: cn(
          "block w-full bg-interactive-subtle-surface px-4 py-3 text-left text-foreground",
          {
            "gap-4 py-5": size === "lg",
            "hover:bg-interactive-subtle-surface-hover": isInteractive,
            "bg-interactive-surface hover:bg-interactive-surface": isSelected
          },
          className
        ),
        ...props
      }
    );
  }
);

export {
  DEFAULT_SIZE,
  ListItem
};
